export const SEND_MAIL = 'mail/sendgrid/SEND_MAIL';
export const RESEND_MAIL = 'mail/apiApp/SEND_MAIL';
export const RESEND_MAIL_SUCESS = 'mail/apiApp/RESEND_MAIL_SUCESS';